import {NgModule} from '@angular/core';
import {} from '@angular/common';
import {DirectivesModule} from '../directives/directives.module';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {SuiModule} from 'ng2-semantic-ui';

@NgModule({
    imports: [],
    declarations: [],
    exports: [
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DirectivesModule,
        SuiModule,
    ]
})
export class SharedImportsModule {
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/modules/shared-imports.module.ts